import {
  COMPLETE_USER_SUBMISSION_FAIL,
  COMPLETE_USER_SUBMISSION_REQUEST,
  COMPLETE_USER_SUBMISSION_SUCCESS,
  GET_CERTIFICATE_PUBLIC_URL_FAIL,
  GET_CERTIFICATE_PUBLIC_URL_REQUEST,
  GET_CERTIFICATE_PUBLIC_URL_SUCCESS,
  GETALL_SUBMITTEDUSERS_FAIL,
  GETALL_SUBMITTEDUSERS_REQUEST,
  GETALL_SUBMITTEDUSERS_SUCCESS,
} from "../../constants/Admin-Panels/adminPanelConstants";

export const getAllSubmittedUsersReducer = (state = {}, action) => {
  switch (action.type) {
    case GETALL_SUBMITTEDUSERS_REQUEST:
      return {
        loading: true,
      };
    case GETALL_SUBMITTEDUSERS_SUCCESS:
      return {
        loading: false,
        success: true,
        getAllSubmittedUsers: action.payload,
      };
    case GETALL_SUBMITTEDUSERS_FAIL:
      return {
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const completeUserSubmissionReducer = (state = {}, action) => {
  switch (action.type) {
    case COMPLETE_USER_SUBMISSION_REQUEST:
      return {
        loading: true,
      };
    case COMPLETE_USER_SUBMISSION_SUCCESS:
      return {
        loading: false,
        success: true,
        completedSubmission: action.payload,
      };
    case COMPLETE_USER_SUBMISSION_FAIL:
      return {
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
export const getCertificatePublicUrlReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CERTIFICATE_PUBLIC_URL_REQUEST:
      return {
        loading: true,
      };
    case GET_CERTIFICATE_PUBLIC_URL_SUCCESS:
      return {
        loading: false,
        success: true,
        certificatePublicData: action.payload,
      };
    case GET_CERTIFICATE_PUBLIC_URL_FAIL:
      return {
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
